import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { of } from "rxjs";
import { catchError, concatMap, filter, map, take, tap } from "rxjs/operators";
import { serverAccountInfoModel } from "../models/serverResponse.model";
import { AccountService } from "../services/account.service";
import { AccountActions } from "./account-action-types";
import { UserInformationLoaded } from "./account-actions";

@Injectable()
export class AccountEffects{

    constructor(
        private actions$:Actions,
        private accountService:AccountService,
        private router: Router,
        private store:Store
    ){}

    loadUserInfo$ = createEffect(
        () => this.actions$.pipe(
            ofType(AccountActions.loadUserInformation),
            concatMap(() => 
                this.accountService.getAccountInfo().pipe(
                    map(accountResponse => accountResponse.accountInfo),
                    catchError(err => {
                        this.store.dispatch(AccountActions.UserInformationUnreachable());
                        return of([]);
                    }),
                )
            ),
            filter(data => data && data?.length !== 0),
            map(userInfo => UserInformationLoaded({userInfo})),
        )
    );

    loadUserInfoFailed$ = createEffect(
        () => this.actions$.pipe(
            ofType(AccountActions.UserInformationUnreachable),
            tap(() => this.router.navigate(['home',{outlets: { account: ['login']}}], {skipLocationChange: true}))
        ),
        {dispatch: false}
    )

}